import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=1768c380&"
import script from "./Inform.vue?vue&type=script&lang=js&"
export * from "./Inform.vue?vue&type=script&lang=js&"
import style0 from "./Inform.vue?vue&type=style&index=0&id=1768c380&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports